import type { DailyRun } from '@cradle7/shared';
import { useSyncExternalStore } from 'react';

let active: DailyRun | null = null;
const listeners = new Set<() => void>();

function emit() {
  listeners.forEach((fn) => fn());
}

export function getActiveDailyRun(): DailyRun | null {
  return active;
}

export function setActiveDailyRun(d: DailyRun): void {
  active = d;
  emit();
}

export function clearActiveDailyRun(): void {
  active = null;
  emit();
}

export function subscribeDailyRun(fn: () => void): () => void {
  listeners.add(fn);
  return () => { listeners.delete(fn); };
}

/** Test hook: clear in-memory state + listeners. */
export function _clearDailyStore(): void {
  active = null;
  listeners.clear();
}

/** Milliseconds until the next 00:00:00.000 UTC strictly after `now`. */
export function msUntilNextUtcMidnight(now: Date = new Date()): number {
  const next = new Date(Date.UTC(
    now.getUTCFullYear(),
    now.getUTCMonth(),
    now.getUTCDate() + 1,
    0, 0, 0, 0,
  ));
  return next.getTime() - now.getTime();
}

let snapshotCache: { active: DailyRun | null } | null = null;
let snapshotKey: DailyRun | null = null;

export function getDailySnapshot(): { active: DailyRun | null } {
  if (snapshotCache && snapshotKey === active) return snapshotCache;
  snapshotCache = { active };
  snapshotKey = active;
  return snapshotCache;
}

export function useDailyRun(): { active: DailyRun | null } {
  return useSyncExternalStore(subscribeDailyRun, getDailySnapshot, getDailySnapshot);
}
